import {
  MEMBER_DELETE_MEMBER_BEGIN,
  MEMBER_DELETE_MEMBER_SUCCESS,
  MEMBER_DELETE_MEMBER_FAILURE,
  MEMBER_DELETE_MEMBER_DISMISS_ERROR,
} from './constants';


import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';
let tableRef = null;


// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function deleteMember(_tableRef, memberID,args = {}) {

  tableRef = _tableRef;
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: MEMBER_DELETE_MEMBER_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      axios.post(SERVER_PATH + '/members/edit', {
        member:{
        "member":memberID+'',
        "status":"0"
        }
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          dispatch({
            type: MEMBER_DELETE_MEMBER_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: MEMBER_DELETE_MEMBER_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissDeleteMemberError() {
  return {
    type: MEMBER_DELETE_MEMBER_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MEMBER_DELETE_MEMBER_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        deleteMemberPending: true,
        deleteMemberError: null,
      };

    case MEMBER_DELETE_MEMBER_SUCCESS:
      tableRef.current && tableRef.current.onQueryChange();
      // The request is success
      return {
        ...state,
        deleteMemberPending: false,
        deleteMemberError: null,
      };

    case MEMBER_DELETE_MEMBER_FAILURE:
      // The request is failed
      return {
        ...state,
        deleteMemberPending: false,
        deleteMemberError: action.data.error,
      };

    case MEMBER_DELETE_MEMBER_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        deleteMemberError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/member/redux/deleteMember.js